import "./FloatingPrizes.scss";
import ProductImage from "../ProductImage/ProductImage";

// До трьох картинок призів, що повільно ширяють; перша — більша й по центру.
// Розміри задає батьківський блок (className), картинки займають його цілком.
const FloatingPrizes = ({ images, className = "" }: { images: string[], className?: string }) => (
    <div className={`fp ${className}`} aria-hidden="true">
        { images.slice(0, 3).map((src, i) =>
            <ProductImage key={`${i}-${src}`} className={`fp-item fp-item-${i}`} src={src} alt="" draggable={false} />
        )}
    </div>
);

export default FloatingPrizes;
